import React, { useState, useEffect } from 'react';
import { usePricingCalendar } from '../hooks/usePricingCalendar';

/**
 * Countdown Timer Component
 * Se actualizează automat bazat pe calendarul de scumpiri
 */
const CountdownTimer = ({ pricingTiers, wrapperId, targetDate }) => {
  const { timerTargetDate } = usePricingCalendar(pricingTiers);
  const [timeLeft, setTimeLeft] = useState({
    days: 0,
    hours: 0,
    minutes: 0,
    seconds: 0,
  });
  const [expired, setExpired] = useState(false);

  useEffect(() => {
    const effectiveTargetDate = targetDate ? new Date(targetDate) : timerTargetDate;
    if (!effectiveTargetDate || Number.isNaN(effectiveTargetDate.getTime())) {
      setExpired(true);
      return;
    }

    const updateTimer = () => {
      const now = new Date().getTime();
      const target = effectiveTargetDate.getTime();
      const distance = target - now;

      if (distance < 0) {
        setExpired(true);
        setTimeLeft({ days: 0, hours: 0, minutes: 0, seconds: 0 });
        return;
      }

      setExpired(false);
      setTimeLeft({
        days: Math.floor(distance / (1000 * 60 * 60 * 24)),
        hours: Math.floor((distance % (1000 * 60 * 60 * 24)) / (1000 * 60 * 60)),
        minutes: Math.floor((distance % (1000 * 60 * 60)) / (1000 * 60)),
        seconds: Math.floor((distance % (1000 * 60)) / 1000),
      });
    };

    // Update immediately
    updateTimer();

    // Update every second
    const interval = setInterval(updateTimer, 1000);

    return () => clearInterval(interval);
  }, [timerTargetDate, targetDate]);

  const wrapperProps = { className: 'banner-timer' };
  if (wrapperId) wrapperProps.id = wrapperId;

  if (expired) {
    return (
      <div {...wrapperProps}>
        <div className="timer-block">
          <span className="timer-number">00</span>
          <span className="timer-label">Zile</span>
        </div>
        <div className="timer-divider">:</div>
        <div className="timer-block">
          <span className="timer-number">00</span>
          <span className="timer-label">Ore</span>
        </div>
        <div className="timer-divider">:</div>
        <div className="timer-block">
          <span className="timer-number">00</span>
          <span className="timer-label">Min</span>
        </div>
        <div className="timer-divider">:</div>
        <div className="timer-block">
          <span className="timer-number">00</span>
          <span className="timer-label">Sec</span>
        </div>
      </div>
    );
  }

  return (
    <div {...wrapperProps}>
      <div className="timer-block">
        <span className="timer-number">{String(timeLeft.days).padStart(2, '0')}</span>
        <span className="timer-label">Zile</span>
      </div>
      <div className="timer-divider">:</div>
      <div className="timer-block">
        <span className="timer-number">{String(timeLeft.hours).padStart(2, '0')}</span>
        <span className="timer-label">Ore</span>
      </div>
      <div className="timer-divider">:</div>
      <div className="timer-block">
        <span className="timer-number">{String(timeLeft.minutes).padStart(2, '0')}</span>
        <span className="timer-label">Min</span>
      </div>
      <div className="timer-divider">:</div>
      <div className="timer-block">
        <span className="timer-number">{String(timeLeft.seconds).padStart(2, '0')}</span>
        <span className="timer-label">Sec</span>
      </div>
    </div>
  );
};

export default CountdownTimer;












